import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

async function getWorkshopVerificationRequestQuery(apiClient: ApiClient, id: string) {
  return apiClient.GET('/op/v2/workshop-verification-request/{id}', {
    params: { path: { id } },
  });
}

export default function useWorkshopVerificationRequestQuery(id?: string) {
  const toast = useToast();
  const apiClient = useApiClient();

  const query = useQuery<InferFetchData<typeof getWorkshopVerificationRequestQuery>, ApiError>({
    queryKey: getKey(id),
    queryFn: () => throwOnError(getWorkshopVerificationRequestQuery(apiClient, id!)),
    enabled: !!id,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(id?: string | number): QueryKey {
  return ['WorkshopVerificationRequest', String(id)] as const satisfies QueryKey;
}

useWorkshopVerificationRequestQuery.getKey = getKey;
